define('views/modules/calendar/personal-data/item/form/personal-data-details-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/calendar/personal-data/personal-data-types',
    'models/calendar/personal-data/personal-data-type',
    // views
    'views/parts/info-section',
    'views/parts/form/select',
    'views/parts/form/textbox',
    // services
    'services/i18n',
    'services/app-state',
    // templates
    'text!templates/modules/calendar/personal-data/item/form/personal-data-details-form.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CPersonalDataTypes,
    MPersonalDataType,
    // views
    VInfoSection,
    VSelect,
    VTextbox,
    // services
    i18n,
    AppState,
    // templates
    TPersonalDataDetailsForm
) {

    var VPersonalDataDetailsForm = Backbone.Epoxy.View.extend({
        template: TPersonalDataDetailsForm,

        regions: {
            dataType: ".form-data-type",
            dataValue: ".form-data-value",
        },

        initialize: function() {
            this.collection = new CPersonalDataTypes();

            this.currentPersonalData = new MPersonalDataType({ unit: "" });
            this.bindingSources = { type: this.currentPersonalData };

            this.view = {
                info: new VInfoSection({
                    title: "Details Form",
                    content: this.template,
                    help: 'calendar:custom-data-tutorial-text'
                }),
                dataType: new VSelect({
                    label: 'calendar:data-to-enter',
                    labelposition: "top",
                    option: { label: 'name', value: MPersonalDataType.prototype.idAttribute },
                    attribute: 'customData',
                    model: this.model,
                    collection: this.collection
                }),
                dataValue: new VTextbox({
                    type: 'number',
                    label: 'calendar:result',
                    attribute: 'value',
                    labelposition: 'outer',
                    addon: true,
                    addonBefore: this.model.get("unit"),
                    model: this.model,
                }),
            };

            if (! AppState.onClientSide()) {
                this.view.dataValue.setHelpText('calendar:personal-data-value-helptext');
            }

            this.selectedValue = U.urlParam('itemId');

            this.listenTo(this.collection, 'sync', this.onCollectionSync);

            this.listenTo(this.model, {
                "change:customData": this.onCustomDataChange
            });
        },

        render: function() {
            var view = this.view;

            this.view.dataValue.options.addonBefore = this.model.get("unit");

            this.assign(view.info, this.$el);

            this.generateZones();
            var zone = this.zone;

            this.model.set('value', this.model.getValue());
            this.model.set('unit', this.model.getUserUnit());

            this.currentPersonalData.set('unit', this.model.getUserUnit());

            this.assign(view.dataType, zone.$dataType)
                .assign(view.dataValue, zone.$dataValue)
                .setDefaultValue(this.model.getValue())
                .setUnitAddon(i18n.t(i18n.t(this.model.get('unit'))))
                .applyBindings();

            this.collection.fetch();

            return this;
        },

        setDefaultValue: function(value) {
            this.view.dataValue.setInputValue(value);
            return this;
        },

        setUnitAddon: function(unit) {
            this.view.dataValue.setAddonBefore(unit);
            return this;
        },

        getCustomDataDef: function() {
            return this.collection.get(this.view.dataType.getValue());
        },

        onCustomDataChange: function() {
            var dataType = this.getCustomDataDef();

            if (dataType) {
                this.currentPersonalData.reset(dataType.attributes);
                this.model.set('unit', dataType.getUserUnit());
                this.render();
            }
        },

        onCollectionSync: function() {
            if (this.selectedValue) {
                this.view.dataType.setValue(this.selectedValue);
                this.view.dataType.setDisable(true);
            }
            
            // Populate description for existing entries
            if (this.model.get('customData')) {
                var dataType = this.getCustomDataDef();
                if (dataType) {
                    this.currentPersonalData.reset(dataType.attributes);
                }
            }
        }
    });

    return VPersonalDataDetailsForm;

});

